import script from "./header-main.vue?vue&type=script&setup=true&lang=js"
export * from "./header-main.vue?vue&type=script&setup=true&lang=js"

import "./header-main.vue?vue&type=style&index=0&id=5abdea2e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5abdea2e"]])

export default __exports__